import { SortDirection } from '@mui/material';
import theme from 'theme';
import { ModelsTableHeadColumn } from '../../ModelsTable/ModelsTable.types';

const createSortHandler = (onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void) => (property: string) => (event: React.MouseEvent<unknown>) => {
  onRequestSort(event, property);
};

const orderHandler = (sortArg: string, sortDefault: SortDirection, orderBy: string, order: SortDirection) => {
  if (orderBy === sortArg) {
    return order;
  }
  return sortDefault;
};

const isActive = (headCell: ModelsTableHeadColumn, orderBy: string) => orderBy === headCell.id;

const getSortIconStyle = (headCell: ModelsTableHeadColumn, orderBy: string) => ({
  icon: {
    width: '10%',
    ...(isActive(headCell, orderBy) && { color: `${theme.palette.primary.dark} !important`, opacity: 1 }),
    ...(!isActive(headCell, orderBy) && { opacity: 0.2 }),
  },
});

export {
  createSortHandler,
  orderHandler,
  isActive,
  getSortIconStyle,
}